import Search from '../../components/SearchFilter'
import TableAntd from '../../components/TableAntd'
import useHook from './hooks'
import RadioTabs from '../../components/RadioTabs'
import CustomModal from '../../components/ModalUser'
import { Button, Empty, ConfigProvider } from 'antd'
import emptyImage from '../../assets/img/empty.png'

export default function MessageCenter() {
  const {
    isTableLoading,
    dateSource,
    handleSearchClick,
    pagination,
    handlePaginationChange,
    currentRadioDict,
    handleCheckedChange,
    confirmVisible,
    onConfirmDeleteScheme,
    openModal,
    jumpDetail,
    record,
  } = useHook()
  const listColumn = [
    {
      key: 'content',
      title: '消息内容',
      render: (text: any, record: any) => {
        // 兼容title字段，如果title存在且不为空则使用title，否则使用content
        const displayText =
          record.title && record.title.trim() !== '' ? record.title : text
        return (
          <div>
            <span
              style={{
                cursor: 'pointer',
                color: record.isRead
                  ? 'rgba(0, 0, 0, 0.7)'
                  : 'rgb(29, 74, 189)',
              }}
              onClick={() => openModal(record)}
            >
              {displayText}
            </span>
          </div>
        )
      },
    },
    {
      key: 'time',
      title: '时间',
      width: 100,
    },
    {
      key: 'typeToName',
      title: '类型',
      width: 100,
    },
  ]
  const modalNode = (
    <div>
      <p style={{ fontSize: '20px', fontWeight: 600 }}>{record?.content}</p>
      {}
      <span onClick={jumpDetail} className="btn-link">
        {'前往处理>>'}
      </span>
      <div style={{ textAlign: 'center', paddingTop: '10px' }}>
        <Button type="primary" onClick={onConfirmDeleteScheme}>
          确定
        </Button>
      </div>
    </div>
  )

  return (
    <div>
      <Search
        fieldsData={['content', 'messageType']}
        onSearch={handleSearchClick}
        keyName="MESSAGECENTER"
        ScreenKey="MESSAGECENTER"
      />
      <div>
        <div style={{ padding: '10px' }}>
          <RadioTabs
            defaultKey={'全部'}
            radioItemDict={currentRadioDict}
            onChange={handleCheckedChange}
          ></RadioTabs>
        </div>
        <ConfigProvider
          renderEmpty={() => (
            <Empty description="暂无消息通知" image={emptyImage} />
          )}
        >
          <TableAntd
            dataSource={dateSource}
            listColumn={listColumn}
            loading={isTableLoading}
            Y={340}
            pagination={{
              ...pagination,
              onChange: handlePaginationChange,
            }}
            showSize
          ></TableAntd>
        </ConfigProvider>
      </div>
      <CustomModal
        width={470}
        open={confirmVisible}
        title={'消息详情'}
        footer={false}
        modalCancel={onConfirmDeleteScheme}
      >
        {modalNode}
      </CustomModal>
    </div>
  )
}
import Search from '../../components/SearchFilter'
import TableAntd from '../../components/TableAntd'
import useHook from './hooks'
import RadioTabs from '../../components/RadioTabs'
import CustomModal from '../../components/ModalUser'
import { Button, Empty, ConfigProvider } from 'antd'
import emptyImage from '../../assets/img/empty.png'

export default function MessageCenter() {
  const {
    isTableLoading,
    dateSource,
    handleSearchClick,
    pagination,
    handlePaginationChange,
    currentRadioDict,
    handleCheckedChange,
    confirmVisible,
    onConfirmDeleteScheme,
    openModal,
    jumpDetail,
    record,
  } = useHook()
  const listColumn = [
    {
      key: 'content',
      title: '消息内容',
      render: (text: any, record: any) => {
        // 兼容title字段，如果title存在且不为空则使用title，否则使用content
        const displayText =
          record.title && record.title.trim() !== '' ? record.title : text
        return (
          <div>
            <span
              style={{
                cursor: 'pointer',
                color: record.isRead
                  ? 'rgba(0, 0, 0, 0.7)'
                  : 'rgb(29, 74, 189)',
              }}
              onClick={() => openModal(record)}
            >
              {displayText}
            </span>
          </div>
        )
      },
    },
    {
      key: 'time',
      title: '时间',
      width: 100,
    },
    {
      key: 'typeToName',
      title: '类型',
      width: 100,
    },
  ]
  const modalNode = (
    <div>
      <p style={{ fontSize: '20px', fontWeight: 600 }}>{record?.content}</p>
      {}
      <span onClick={jumpDetail} className="btn-link">
        {'前往处理>>'}
      </span>
      <div style={{ textAlign: 'center', paddingTop: '10px' }}>
        <Button type="primary" onClick={onConfirmDeleteScheme}>
          确定
        </Button>
      </div>
    </div>
  )

  return (
    <div>
      <Search
        fieldsData={['content', 'messageType']}
        onSearch={handleSearchClick}
        keyName="MESSAGECENTER"
        ScreenKey="MESSAGECENTER"
      />
      <div>
        <div style={{ padding: '10px' }}>
          <RadioTabs
            defaultKey={'全部'}
            radioItemDict={currentRadioDict}
            onChange={handleCheckedChange}
          ></RadioTabs>
        </div>
        <ConfigProvider
          renderEmpty={() => (
            <Empty description="暂无消息通知" image={emptyImage} />
          )}
        >
          <TableAntd
            dataSource={dateSource}
            listColumn={listColumn}
            loading={isTableLoading}
            Y={340}
            pagination={{
              ...pagination,
              onChange: handlePaginationChange,
            }}
            showSize
          ></TableAntd>
        </ConfigProvider>
      </div>
      <CustomModal
        width={470}
        open={confirmVisible}
        title={'消息详情'}
        footer={false}
        modalCancel={onConfirmDeleteScheme}
      >
        {modalNode}
      </CustomModal>
    </div>
  )
}
